import { observe } from "jotai-effect";
import { saveState } from "utilities/atoms/conversations/conversations.persistence";
import {
    BookviewConversationAtom,
    ModalConversationAtom,
} from "./current-conversation/conversation-atoms";
import { ConversationHistoryAtom } from "./conversation-history/conversation-history-atom";

export function conversationsAtomPersistenceEffect() {
    return observe((get) => {
        const modalConversation = get(ModalConversationAtom);
        const bookviewConversation = get(BookviewConversationAtom);
        const conversationHistory = get(ConversationHistoryAtom);

        saveState("modalConversation", modalConversation);
        saveState("bookviewConversation", bookviewConversation);
        saveState("conversationHistory", conversationHistory);
    });
}
